import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlGenBirimAramaComponent } from './ctl-gen-birim-arama/ctl-gen-birim-arama.component';
import { GenBirimService } from './ctl-gen-birim.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { IkaBirimKatsayi } from 'libs/ika/src/lib/models/ika.models';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
import { DkGlobalUserSettingsService } from '../../../services/dk-global-user-settings.service';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'dk-ctl-gen-birim',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlGenBirimAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [GenBirimService],
  templateUrl: './ctl-gen-birim.component.html',
  styleUrls: ['./ctl-gen-birim.component.scss'],
})
export class CtlGenBirimComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = this.globalSettings.globalLabelMode;
  public crudPopupVisible = false;
  public title!: string;
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  public checkedData: any;
  public toastVisible = false;
  public toastMessage = "Bu birim kullanılıyor. Bir önceki ekrandan düzenleyebilir veya farklı bir birim seçebilirsiniz.";
  public isFirst = true;
  public control!: any;
  controlName = "GenBirim";
  @Input() code: any;
  @Input() isYetki: boolean = false;
  @Input() checkData = false;
  @Input() birimTuru: string;
  @Input() isActive = false;
  @Input() validationRulesMap:any[] = [];
  @Input() validationV2= false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: GenBirimService, private utilsService: UtilsService , private ortakService: OrtakService,
    private globalSettings:DkGlobalUserSettingsService
  ) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if(this.birimTuru || this.checkData) this.service.setParams(this.birimTuru,this.checkData, this.isActive,this.isReadOnly,this.isBindCheck,this.isYetki)
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.birimTuru,this.checkData, this.isActive,this.isReadOnly,this.isBindCheck,this.isYetki)
      }
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,this.birimTuru,true);
        }
    });
  }
  searchClick() {
    this.crudPopupVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (e === '' || e === null) this.clear();
    else this.getData(e,this.birimTuru);
  }

  getData(code: any, birimTuru:string, isSetData?: boolean) {
    if(this.checkData){
      this.checkedData = this.service.getCheckData(Number(code));
      this.checkedData.load().done((result: any) => {
        if (result.length > 0) {
          this.toastVisible = true
          return
        } else if (result[0].Kod === code) return
        else this.getDataWithCode(code,birimTuru,isSetData)
      });
    }
    else this.getDataWithCode(code,birimTuru,isSetData)



  }

  getDataWithCode(code: any, birimTuru:string, isSetData?: boolean){
    // this.data = this.service.getData(Number(code),birimTuru);
    // this.data.load().done((result: any) => {
    //   if (result.length > 0) {
    //     this.title = result[0].Ad;
    //     this.code = result[0].Kod;
    //     this.dataResult.emit(result[0]);
    //   } else {
    //     this.utilsService.showError('Bulunamadı');
    //     this.clear();
    //   }
    // });
    if(this.control){
    this.data = this.service.getData(Number(code),this.control,birimTuru,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        this.code = result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });
  }
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

